import React from 'react';
import PropTypes from 'prop-types';
import { ItemOrderGroup } from '../ItemOrderGroup';
import { ItemList } from './ItemList';

export const EligibleItems = ({
  showGroups = false,
  orderGroups,
  onSelectItem,
  returnCart,
  items,
}) =>
  (showGroups && orderGroups) || orderGroups.length > 1 ? (
    orderGroups.map((group) => (
      <ItemOrderGroup
        key={group.order.order_info.order_number}
        group={group}
        onClick={onSelectItem}
        returnCart={returnCart}
      />
    ))
  ) : (
    <ItemList items={items} onClick={onSelectItem} selected={returnCart.map((e) => e.item_id)} />
  );

EligibleItems.propTypes = {
  showGroups: PropTypes.bool.isRequired,
  orderGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectItem: PropTypes.func.isRequired,
  returnCart: PropTypes.arrayOf(PropTypes.object).isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
};
